import { css } from 'lit';

export const modalStyles = css`
    @unocss-placeholder;

    :host {
        display: contents;
    }

    w-modal-footer::part(footer) {
        padding-top: 0;
    }
`;
